import {
  GenericDesignChangeItem,
  GenericLinkDesignChangeItem,
  GenericNodeDesignChangeItem,
  GenericObjectDesignChangeItem
} from '../../../../types';

export function getChangeItemObject<
  T extends GenericDesignChangeItem
>(
  changeItem: T
): (
  T extends GenericLinkDesignChangeItem
    ? T['link']
    : T extends GenericNodeDesignChangeItem
      ? T['node']
      : T extends GenericObjectDesignChangeItem
        ? T['object']
        : never
  ) {
  if ('link' in changeItem) {
    return changeItem.link as any;
  } else if ('node' in changeItem) {
    return changeItem.node as any;
  }

  return changeItem.object as any;
}
